import { render } from "./ContractPage.vue?vue&type=template&id=db2e0542"
import script from "./ContractPage.vue?vue&type=script&lang=js"
export * from "./ContractPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__